export default __webpack_public_path__ + "static/media/Handguards of Conflagrant Flame.5592265b.jpg";